import dayjs from "dayjs";
import {
  CancelledTrip,
  UnpublishedBooking,
  LatestModification,
} from "../../hooks/react-query/linehaul/useEndOfShiftReports";
import { EndOfShiftComment } from "../../hooks/react-query/linehaul/useEndOfShiftComments";

export const yardCheck = {
  default: [
    {
      id: "c8331cd9-d9ad-4318-88d9-57abfeebf3ca_20250404000000.pdf",
      name: "dummy.pdf (1)",
      uploadedBy: "Marley Ferreira",
      format: "PDF",
      uploadedDate: "2025-05-14T07:15:47.361185",
      url: "apex-linehaul-dev:documents/c8331cd9-d9ad-4318-88d9-57abfeebf3ca_20250404000000.pdf",
    },
    {
      id: "01590753-fd80-4d40-90f7-f4431ee3fe62_20250404000000.pdf",
      name: "dummy.pdf (2)",
      uploadedBy: "Marley Ferreira",
      format: "PDF",
      uploadedDate: "2025-05-14T07:17:16.082307",
      url: "apex-linehaul-dev:documents/01590753-fd80-4d40-90f7-f4431ee3fe62_20250404000000.pdf",
    },
    {
      id: "ed731451-1e44-4deb-8841-480a38cd91ae_20250404000000.pdf",
      name: "dummy.pdf",
      uploadedBy: "Marley Ferreira",
      format: "PDF",
      uploadedDate: "2025-05-14T07:14:36.035592",
      url: "apex-linehaul-dev:documents/ed731451-1e44-4deb-8841-480a38cd91ae_20250404000000.pdf",
    },
  ],
};

export const yardCheckFileUpload = {
  success: {
    fileUrl: "apex-linehaul-dev:documents/uploaded-document-12345.pdf",
    message: "File uploaded successfully",
  },
  errors: {
    noFile: { message: "No file provided" },
    fileTooLarge: { message: "File size exceeds maximum allowed limit" },
    invalidFileType: {
      message:
        "Invalid file type. Only PDF, DOC, DOCX, XLSX, CSV files are allowed",
    },
    serverError: { message: "Internal server error" },
  },
  yardCheckWithNewlyUploadedFile: [
    ...yardCheck.default,
    {
      id: "new-uploaded-file-12345_20250514000000.pdf",
      name: "new-yard-check-report.pdf",
      uploadedBy: "Test User",
      format: "PDF",
      uploadedDate: "2025-05-14T08:30:00.000000",
      url: "apex-linehaul-dev:documents/new-uploaded-file-12345_20250514000000.pdf",
    },
  ],
  updatedReportHeader: {
    laneProjectionsCount: 2,
    unpublishedBookingsCount: 30,
    cancelledCount: 30,
    yardCheckCount: 4,
  },
};

export const unpublishedBookings = {
  default: [
    {
      scheduleId: 3045277,
      destinationSicCode: "SFO",
      carrierEmployee: "L004 - COVENANT TRANSPORT INC",
      bookingNumber: "TOM/JOSHUA",
      pickupDate: dayjs("2024-10-19T10:00:00"),
      confirmationStatus: "Confirmed",
    },
    {
      scheduleId: 3045195,
      destinationSicCode: "ONT",
      carrierEmployee: "M163 - AVILENO TRUCKING LLC",
      bookingNumber: "ARMANDO/SANTIAGO",
      pickupDate: dayjs("2024-10-19T09:00:00"),
      confirmationStatus: "PendingConfirmation",
    },
    {
      scheduleId: 3045362,
      destinationSicCode: "ONT",
      carrierEmployee: "L027 - C R ENGLAND INC",
      bookingNumber: "OLIVE",
      pickupDate: dayjs("2024-10-19T10:00:00"),
      confirmationStatus: "PendingConfirmation",
    },
  ],
} as const satisfies Record<string, UnpublishedBooking[]>;

export const laneProjections = [
  {
    originSicId: 111,
    originSicCode: "ONT",
    destinationSicId: 4,
    destinationSicCode: "BOS",
    mergedLanes: [
      {
        sicId: 18,
        sicCode: "ATL",
      },
    ],
    hasMergedLanes: true,
    tripSummaries: [
      {
        tripNumber: 3109656,
        originSicId: 111,
        destinationSicId: 4,
        trailer: null,
        bookingNumber: "ANTHONY/DERWIN",
        priorityNumber: "1",
        carrierEmployee: "M199 - MARSA TRANSPORTATION INC",
        isTrailerInYard: false,
        stops: [],
      },
      {
        tripNumber: 3109960,
        originSicId: 111,
        destinationSicId: 18,
        trailer: null,
        bookingNumber: "OLIVE",
        priorityNumber: "2",
        carrierEmployee: "L027 - C R ENGLAND INC",
        isTrailerInYard: false,
        stops: [],
      },
      {
        tripNumber: 3110053,
        originSicId: 111,
        destinationSicId: 84,
        trailer: null,
        bookingNumber: "901090",
        priorityNumber: "2",
        carrierEmployee: "L335 - PATIALA EXPRESS INC DBA PEI OHIO INC",
        isTrailerInYard: false,
        stops: [],
      },
      {
        tripNumber: 3109959,
        originSicId: 111,
        destinationSicId: 164,
        trailer: null,
        bookingNumber: "VERONICA/KAMILAH ",
        priorityNumber: "1",
        carrierEmployee: "M244 - LEBONMEX INC",
        isTrailerInYard: false,
        stops: [],
      },
    ],
    shipmentSummaries: [
      {
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 4,
        destinationSicCode: "BOS",
        totalWeight: 464,
        weightUnit: "lbs",
        totalPallets: 3,
        totalPieces: 3,
        bills: 3,
        averagePower: 0,
      },
      {
        originSicId: 111,
        originSicCode: "ONT",
        destinationSicId: 18,
        destinationSicCode: "ATL",
        totalWeight: 17400,
        weightUnit: "lbs",
        totalPallets: 8,
        totalPieces: 0,
        bills: 2,
        averagePower: 0.6,
      },
    ],
    shipmentSummaryTotals: {
      weightUnit: "lbs",
      totalWeight: 17864,
      totalPallets: 11,
      totalPieces: 3,
      bills: 5,
      averagePower: 0.3,
    },
  },
  {
    originSicId: 111,
    originSicCode: "ONT",
    destinationSicId: 10,
    destinationSicCode: "BWI",
    mergedLanes: [],
    hasMergedLanes: false,
    tripSummaries: [
      {
        tripNumber: 3109568,
        originSicId: 111,
        destinationSicId: 10,
        trailer: null,
        bookingNumber: "PENGHUAI/YANKUM",
        priorityNumber: "1",
        carrierEmployee: "M217 - WYZ TRANSPORTATION INC",
        isTrailerInYard: false,
        stops: [],
      },
    ],
    shipmentSummaries: [],
    shipmentSummaryTotals: {
      weightUnit: "lbs",
      totalWeight: 0,
      totalPallets: 0,
      totalPieces: 0,
      bills: 0,
      averagePower: 0,
    },
  },
];

export const reportHeader = {
  laneProjectionsCount: 2,
  unpublishedBookingsCount: 30,
  cancelledCount: 30,
  yardCheckCount: 3,
};

export const cancelledTrips = {
  default: [
    {
      scheduleId: 3045263,
      destinationSicCode: "ONT",
      originSicCode: "ATB-SEFL",
      bookingNumber: "6095933",
      tripNumber: 3111228,
      cancelledStatus: "DyltCancelled",
      cancelledBy: "",
      pickupDate: dayjs("2024-10-19T10:00:00"),
      carrierEmployee: "L004 - COVENANT TRANSPORT INC",
      tonu: 0,
    },
  ],
} as const satisfies Record<string, CancelledTrip[]>;

const defaultComments = [
  {
    id: "b58af48d-3fbd-454a-9fcf-64c967c8f1eb",
    contextType: "location", // Changed back to location as that's what the component filters for
    contextId: "1", // Match the originSicId from URL
    parentContextId: "164", // Match the originSicId from URL
    createdBy: "7fd75d50-622e-4258-9027-606eb0f11809",
    text: "service center123",
    comment: "service center123",
    type: "flag",
    status: "open",
    modifiedBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    createdOn: dayjs("2025-08-20T20:25:10.042Z"),
    modifiedOn: dayjs("2025-08-20T20:25:21.017Z"),
    contextDate: dayjs("2025-08-20"),
    userName: "Amreeta kura",
    user: "Amreeta kura",
    timestamp: dayjs("2025-08-19T21:25:10.042Z"),
    isEdited: false,
    resolutions: [],
  },
  {
    id: "2e9cf09a-26d4-4d93-b8e5-64f94ac8cd9a",
    contextType: "lane",
    contextId: "2",
    parentContextId: "164", // Match the originSicId from URL  // Match the originSicId from the URL
    createdBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    text: "lane comment123",
    comment: "lane comment123",
    type: "flag",
    status: "unresolved",
    modifiedBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    createdOn: dayjs("2025-08-19T20:45:46.948Z"),
    modifiedOn: dayjs("2025-08-19T20:47:20.403Z"),
    contextDate: dayjs("2025-08-20"),
    userName: "Amreeta kura",
    user: "Amreeta kura",
    timestamp: dayjs("2025-08-19T20:45:46.948Z"),
    isEdited: false,
    resolutions: [],
  },
  {
    id: "a44ff38f-fd61-4e1b-991f-d5065888380f",
    contextType: "lane",
    contextId: "18",
    parentContextId: "164",
    createdBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    text: "lane comment",
    comment: "lane comment",
    type: "flag",
    status: "resolved",
    modifiedBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    createdOn: dayjs("2025-08-20T11:12:01.678Z"),
    modifiedOn: dayjs("2025-08-20T11:16:57.766Z"),
    contextDate: dayjs("2025-08-20"),
    userName: "Amreeta kura",
    user: "Amreeta kura",
    timestamp: dayjs("2025-08-20T11:12:01.678Z"),
    isEdited: false,
    resolutions: [
      {
        id: "ee8a2a92-6663-4175-977e-043b8c61c1f7",
        contextType: "lane",
        contextId: "18",
        parentContextId: "164",
        createdBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
        text: "Resolved",
        type: "resolution",
        status: "default",
        modifiedBy: null,
        createdOn: dayjs("2025-08-25T11:16:57.758Z"),
        modifiedOn: null,
        contextDate: dayjs("2025-08-24"),
        userName: "Amreeta kura",
        isEdited: false,
        resolutions: [],
      },
    ],
  },
  {
    id: "635a3dd4-8279-4b8d-8421-3f5ab9b639d6",
    contextType: "lane",
    contextId: "2",
    parentContextId: "103",
    createdBy: "ab727512-9638-44b3-8ec5-bd1fb846c865",
    text: "test",
    comment: "Other user text",
    type: "flag",
    status: "resolved",
    modifiedBy: null,
    createdOn: dayjs("2025-09-15T09:50:19.683Z"),
    modifiedOn: null,
    contextDate: dayjs("2025-09-15"),
    userName: "Anita",
    user: "Anita",
    timestamp: dayjs("2025-09-15T09:50:19.683Z"),
    isEdited: false,
    resolutions: [
      {
        id: "eeed7b29-932f-4ed6-ab08-8cd04954de91",
        contextType: "lane",
        contextId: "2",
        parentContextId: "103",
        createdBy: "ab727512-9638-44b3-8ec5-bd1fb846c865",
        text: "Resolved by other users",
        type: "resolution",
        status: "default",
        modifiedBy: null,
        createdOn: dayjs("2025-09-15T09:50:32.485Z"),
        modifiedOn: null,
        contextDate: dayjs("2025-09-15"),
        userName: "Anita",
        user: "Anita",
        timestamp: dayjs("2025-09-15T09:50:32.485Z"),
        isEdited: false,
        resolutions: [],
      },
    ],
    laneId: undefined,
  },
] satisfies EndOfShiftComment[];

const resolvedLaneFlag = {
  id: "e9f20b3c-6g74-5d2e-c9b0-0d3g4f5e6g7h",
  contextType: "lane",
  contextId: "4",
  parentContextId: "111",
  createdBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
  text: "Resolved lane flag",
  comment: "Resolved lane flag",
  type: "flag",
  status: "resolved",
  modifiedBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
  lastUpdatedBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
  createdOn: dayjs("2025-08-05T20:16:30.102Z"),
  modifiedOn: dayjs("2025-08-05T20:23:07.868Z"),
  lastUpdatedOn: dayjs("2025-08-05T20:23:07.868Z"),
  contextDate: dayjs("2025-08-05"),
  userName: "Amreeta kura",
  user: "Amreeta kura",
  timestamp: dayjs("2025-08-05T20:16:30.102Z"),
  isEdited: false,
  originSicCode: "ONT",
  destinationSicCode: "BOS",
  resolutions: [
    {
      id: "7cg76218-c4g3-564e-bg4b-888b15c4gb3g",
      text: "Lane issue resolved",
      contextId: "4",
      contextType: "lane",
      parentContextId: "111",
      createdBy: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
      type: "resolution",
      status: "default",
      modifiedBy: null,
      lastUpdatedBy: null,
      createdOn: dayjs("2025-08-05T20:23:07.831Z"),
      modifiedOn: null,
      contextDate: dayjs("2025-08-05"),
      userName: "Amreeta kura",
      user: "Amreeta kura",
      timestamp: dayjs("2025-08-05T20:23:07.831Z"),
      isEdited: false,
      resolutions: [],
    },
  ],
};

export const latestModifications = {
  default: {
    lastUpdatedById: "ab40c5ba-86ab-4ca1-ac96-3b6ea722bae8",
    lastUpdatedOn: dayjs("2025-08-05T20:23:07.868Z"),
    lastUpdatedByName: "Amreeta kura",
  },
} as const satisfies Record<string, LatestModification>;

export const endOfShiftComments = {
  default: defaultComments,
  withResolvedLaneFlag: [...defaultComments, resolvedLaneFlag],
} as const satisfies Record<string, EndOfShiftComment[]>;
